export default __webpack_public_path__ + "static/HTH-homepage-hd-6162b4277f5842a5ac268fa37ff57dfa.jpg";